export default {
  linkList: [
    [
      {
        title: "거래 상품",
        list: [
          {
            label: "외환 거래",
            link: "/tradingproduct?index=0",
          },
          {
            label: "귀금속·에너지 ",
            link: "/tradingproduct?index=1",
          },
          {
            label: "주가 지수",
            link: "/tradingproduct?index=2",
          },
          {
            label: "미국 주식",
            link: "/tradingproduct?index=3",
          },
          {
            label: "ETF",
            link: "/tradingproduct?index=4",
          },
        ],
      },
      {
        title: "거래 도구",
        list: [
          {
            label: "MT4 다운로드",
            link: "/MT4",
          },
          {
            label: "MT5 다운로드",
            link: "/MT5",
          },
          {
            label: "EA 거래 및 지표",
            link: "/tools",
          },
          {
            label: "PAMM",
            link: "/PAMM",
          },
          {
            label: "시장 분석",
            link: "/market-analysis",
          },
        ],
      },
    ],
    [
      {
        title: "거래 관련",
        list: [
          {
            label: "거래계좌",
            link: "/TradingAccount",
          },
          {
            label: "레버리지 & 마진",
            link: "/leverage-margin",
          },
          {
            label: "입출금",
            link: "/funding",
          },
          {
            label: "배당금",
            link: "/dividend",
          },
          {
            label: "기관 서비스",
            link: "/service",
          },
          {
            label: "핀테크",
            link: "/technology",
          },
        ],
      },
    ],
    
    [
      {
        title: "EBC 소개",
        list: [
          {
            label: "WHY EBC",
            link: "/about-us",
          },
          {
            label: "법률 문서",
            link: "/LegalDocumen",
          },
          {
            label: "사회적 책임 ",
            link: "/ESG",
          },
          {
            label: "EBC 뉴스",
            link: "/LearningCenter?tabId=0",
          },
          {
            label: "FAQ",
            link: "https://support.ebchelp.com/hc/ko-kr",
          },
          {
            label: "공식 채널 인증",
            link: "/official-verification",
          },
        ],
      },
      {
        title: "파트너",
        list: [
          {
            label: "FC 바르셀로나 ",
            link: "/FCB",
          },
          {
            label: " 옥스퍼드 대학",
            link: "/partners/oxford",
          },
          {
            label: "제휴 프로그램",
            link: "/affiliate-programmes",
          },
        ],
      },
    ],
    [
        {
          title: "EBC 인기 이벤트",
          list: [
            {
              label: "EBC 백만 달러 실거래 대회 Ⅱ",
              link: "/million-dollar-challenge-2",
            },
            {
              label: "크리에이터 프로그램 ",
              link: "/activityList/creator-incentives",
            },
            {
              label: "펀드매니저 프로그램",
              link: "/pay",
            },
            
            {
              label: "전체 보기",
              link: "/activity",
            },
          ],
        },
  {
          label: "거래 제품",
          link: "/tradingproduct",
        },
        {
          label: "레버리지 & 마진",
          link: "/leverage-margin",
        },
        {
          label: "입출금",
          link: "/funding",
        },
        {
          label: "배당금",
          link: "/dividend",
        },
     
    {
      title: "거래 도구",
      list: [
        {
          label: "MT4 다운로드",
          link: "/MT4",
        },
        {
          label: "MT5 다운로드",
          link: "/MT5",
        },
        {
          label: "EA 거래 및 지표",
          link: "/tools",
        },
        {
          label: "PAMM",
          link: "/PAMM",
        },
        {
          label: "시장 분석",
          link: "/market-analysis",
        },
      ],
    },
    {
      title: "EBC 연구원",
      list: [
        {
          label: "교육 중심",
          link: "/LearningCenter",
        },
        {
          label: "데이터 중심",
          link: "/lab",
        },
      ],
    },
    {
      title: "최신 이벤트",
      list: [
        {
          label: "이벤트",
          link: "/activity?index=0",
        },
        {
          label: "EBC 캠페인",
          link: "/activity?index=1",
        },
      ],
    },
    {
      title: "EBC 소개",
      list: [
        {
          label: "WHY EBC",
          link: "/about-us",
        },
        {
          label: "법률 문서",
          link: "/LegalDocumen",
        },
        {
          label: "사회적 책임",
          link: "/ESG",
        },
        {
          label: "FAQ",
          link: "https://support.ebchelp.com/hc/en-001",
        },
        {
          label: "공식 채널 인증",
          link: "/official-verification",
        },
      ],
    },
    {
      title: "협력 모드",
      list: [
        {
          label: "FC 바르셀로나",
          link: "/FCB",
        },
        {
          label: "제휴 프로그램",
          link: "/affiliate-programmes",
        },
        {
          label: "기관 서비스",
          link: "/service",
        },
        {
          label: "유동성 솔루션",
          link: "/technology",
        },
      ],
    }]
  ],
  context: `
      <p>
        <span class="page-footer-intro-blod">
          EBC Financial Group은 다음과 같은 법인 그룹이 공유하는 공동
          브랜드입니다.<br />
        </span>
        EBC Financial Group(SVG) LLC는 세인트빈센트 그레나딘 금융 서비스
        당국(SVGFSA)의 승인을 받았으며 회사 등록 번호는 353 LLC 2020이며 등록
        주소는 Euro House, Richmond Hill Road, Kingstown, VC0100, St. Vincent
        and the Grenadines입니다.
       
      </p>
      <p>
        <span class="page-footer-intro-blod">관련법인:<br /></span>
        EBC Financial Group (UK) Limited는 영국 금융감독원(Financial Conduct
        Authority)의 허가와 규제를 받습니다. 라이선스 번호: 927552. 웹 사이트 :
        <a target="_blank" href="https://www.ebcfin.co.uk" rel="nofollow"
          >www.ebcfin.co.uk</a
        >
        <br />
        EBC Financial Group (Cayman) Limited는 케이맨 제도 통화 당국(라이선스
        번호: 2038223)의 허가 및 규제를 받습니다. 웹 사이트:
        <a target="_blank" href="https://www.ebcgroup.ky" rel="nofollow"
          >www.ebcgroup.ky</a
        >
        <br />
        EBC Financial (MU) Limited 모리셔스 금융서비스위원회(FSC)의 허가 및
        규제를 받는 금융기관입니다. (라이선스 번호: GB24203273) 등록 주소: 3rd
        Floor, Standard Chartered Tower, Cybercity, Ebene, 72201, Republic of
        Mauritius 본 기관의 웹사이트는 개별적으로 운영됩니다.
        <br />
        EBC Financial Group (Comoros) Limited 코모로 연방 앙주앙
        자치섬(Autonomous Island of Anjouan) 해외 금융 관리국의 허가를 받은
        금융기관입니다. (라이선스 번호: L 15637/EFGC) 등록 주소: Hamchako,
        Mutsamudu, Autonomous Island of Anjouan, Union of Comoros
        <br />
        EBC Financial Group (Australia) Pty Ltd (기업 등록 번호: 619 073 237)
        호주 증권투자위원회(ASIC)의 허가 및 규제를 받는 금융기관입니다. (규제
        번호: 500991) EBC Financial Group (SVG) LLC의 관계사로, 두 개의 독립적인
        법인은 개별적으로 운영 및 관리됩니다. 본 웹사이트에서 제공하는 금융 상품
        및 서비스는 호주 법인이 제공하는 것이 아니며, 해당 법인의 책임 범위에
        포함되지 않습니다.
      </p>
      <p>
        <span class="page-footer-intro-blod"> 회사 주소</span>
        The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom,
        EC3V 4AB. 이메일 주소 :cs@ebc.com . 전화번호: +44 20 3376 9662
      </p>
   <p>
        <span class="page-footer-intro-blod">지역 제한:</span>
        EBC는 다음 지역의 거주자에게 서비스를 제공하지 않습니다. 아프가니스탄,
        벨라루스, 미얀마, 캐나다, 중앙아프리카공화국, 콩고, 쿠바,
        콩고민주공화국, 에리트레아, 아이티, 이란, 이라크, 레바논, 리비아,
        말레이시아, 말리, 북한, 러시아, 소말리아, 수단, 남수단, 시리아,
        우크라이나(크림반도, 도네츠크 및 루한스크 지역 포함), 미국, 베네수엘라,
        예멘.자세한 내용은 FAQ(자주 묻는 질문)을 참고해 주세요.
        <br />
        웹사이트 내 모든 스페인어 콘텐츠는 라틴아메리카 국가를 대상으로 하며, EU
        및 스페인에는 적용되지 않습니다.
        <br />
        본 웹사이트에 게시된 모든 포르투갈어 콘텐츠는 아프리카 지역에만
        해당되며, EU, 포르투갈, 브라질에는 적용되지 않습니다.
      </p>
      <p>
        <span class="page-footer-intro-blod">규정 준수 공지:</span>
        본 웹사이트는 전 세계 어디에서나 접속할 수 있으며, 특정 법인에 한정되지
        않습니다. 고객의 권리와 의무는 선택한 서비스 제공 법인과 해당 관할
        지역의 규제에 따라 달라질 수 있습니다. 또한, 일부 국가에서는 본
        웹사이트에 포함된 문서 및 정보를 열람, 다운로드, 공유, 또는 기타
        방식으로 활용하는 행위가 현지 법률 및 규제에 의해 제한되거나 금지될 수
        있습니다.
      </p>
      <p>
        <span class="page-footer-intro-blod">투자 위험 안내:</span>
        CFD(차액 결제거래)는 복잡한 금융 상품으로, 레버리지로 인해 자금을 잃을
        위험이 높습니다. 마진으로 거래하는 것은 높은 수준의 위험을 동반하며,
        모든 투자자에게 적합하지 않을 수 있습니다. 외환 및 CFD 거래에 앞서
        자신의 거래 목표, 경험 수준, 그리고 위험 수용 능력을 신중하게 고려해야
        합니다. 초기 거래 자본의 일부 또는 전부를 잃을 가능성이 있습니다. 투자
        결정을 내리기 전에 전문가의 조언을 구하고, 관련된 위험을 충분히 이해하는
        것이 중요합니다. 거래를 시작하기 전에 관련된 위험 고지 사항을 반드시
        읽어보시기 바랍니다.
      </p>
  `,
};
